import { padStart } from "lodash";
const prefixMapping = new Map();
export class IdFmt {
    constructor(prefix, 
    // Can never change over time
    randLen, 
    // Can change over time
    idLen) {
        this.prefix = prefix;
        this.randLen = randLen;
        this.idLen = idLen;
        const prevFmt = prefixMapping.get(prefix);
        if (prevFmt)
            console.error(`Prefix ${prefix} already in use by ${prevFmt}`);
        prefixMapping.set(prefix, this);
    }
    format(id) {
        const randNum = Math.round(Math.random() * 10 ** this.randLen);
        const randFrag = padStart(`${randNum}`, this.randLen, "0");
        const idFrag = padStart(`${id}`, this.idLen, "0");
        return `${this.prefix}${randFrag}${idFrag}`;
    }
    extract(id) {
        if (id.match(/^\d+$/)) {
            return id; // Already extracted
        }
        if (id.slice(0, this.prefix.length) !== this.prefix)
            throw new Error(`Invalid ID: Prefix ${this.prefix} not present in id ${id}`);
        const extracted = id.slice(this.prefix.length + this.randLen);
        if (!extracted.match(/^\d+$/))
            throw new Error(`Invalid ID: Unexpected non-numeric fragments found in ${id}`);
        return extracted.replace(/^0*/, "");
    }
    extractIfVal(id) {
        if (id == null)
            return id;
        return this.extract(id);
    }
    static getByPrefix(prefix) {
        return prefixMapping.get(prefix);
    }
    static identifyType(id) {
        if (id.match(/^\d+$/)) {
            return null; // Pure numeric ID, no prefix
        }
        // Try all known prefixes (3 chars)
        for (const prefix of prefixMapping.keys()) {
            if (id.startsWith(prefix)) {
                return prefixMapping.get(prefix);
            }
        }
        return null;
    }
}
export const idOf = (item) => item?.pubId ?? item?.id;
//# sourceMappingURL=id.js.map